import MomentUtils from '@date-io/moment'
import { Button, FormControl, FormGroup, Grid, IconButton, TextField } from '@material-ui/core'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import InputAdornment from '@material-ui/core/InputAdornment'
import MenuItem from '@material-ui/core/MenuItem'
import Toolbar from '@material-ui/core/Toolbar'
import Tooltip from '@material-ui/core/Tooltip'
import ClearIcon from '@material-ui/icons/Clear'
import CloseIcon from '@material-ui/icons/Close'
import EventIcon from '@material-ui/icons/Event'
import 'moment/locale/cs'
import FilterListIcon from '@material-ui/icons/FilterList'
import SearchIcon from '@material-ui/icons/Search'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date'
import moment from 'moment'
import React, { useState } from 'react'
import { TABLE_TYPE, useTableContext } from '../../context/TableContext'
import { EKOM_STATES_LABEL, EKOM_TYPES_LABEL } from '../../utils/enums'
import { useToolbarStyles } from './styles'

const MAX_DATE = 'Datum nesmí být větší než aktuální'
const MIN_DATE = 'Datum nesmí být menší než minimální'
const INVALID_DATE = 'Nevalidní formát data'

export const TableToolbar = () => {
  const classes = useToolbarStyles()

  const { state, updateState, resetState, type } = useTableContext()
  const [dateFrom, setDateFrom] = useState<MaterialUiPickersDate>(state.deliveredAtAfter ? moment(state.deliveredAtAfter) : null)
  const [dateTo, setDateTo] = useState<MaterialUiPickersDate>(state.deliveredAtBefore ? moment(state.deliveredAtBefore).clone().subtract(1, 'd') : null)
  const [searchSubject, setSearchSubject] = useState(state.searchSubject)
  const [searchObject, setSearchObject] = useState(state.searchObject)
  const [searchOrg, setSearchOrg] = useState(state.searchOrg)
  const [isRead, setIsRead] = useState(state.isRead)
  const [isUnRead, setIsUnRead] = useState(state.isUnRead)
  const [msgState, setMsgState] = useState(state.msgState)
  const [msgType, setMsgType] = useState(state.msgType)

  const isFilterActive: boolean = !!state.searchObject || !!state.searchSubject || !!state.searchOrg || !!state.deliveredAtAfter || !!state.deliveredAtBefore || state.isRead || state.isUnRead || !!state.msgState || !!state.msgType
  const isFilterFill: boolean = !!searchObject || !!searchSubject || !!searchOrg || !!dateFrom || !!dateTo || isRead || isUnRead || !!msgState || !!msgType

  const [openFilter, setOpenFilter] = useState(isFilterActive)

  const doFilter = () => {
    updateState({
      searchSubject: searchSubject,
      searchObject: searchObject,
      searchOrg: searchOrg,
      deliveredAtAfter: dateFrom?.format('YYYY-MM-DD'),
      deliveredAtBefore: dateTo?.clone().add(1, 'd').format('YYYY-MM-DD'),
      page: 1,
      isRead: isRead,
      isUnRead: isUnRead,
      msgState: msgState,
      msgType: msgType
    })
  }

  const resetFilter = () => {
    resetState()

    setSearchSubject('')
    setSearchObject('')
    setSearchOrg('')
    setDateFrom(null)
    setDateTo(null)
    setIsRead(false)
    setIsUnRead(false)
    setMsgState('')
    setMsgType('')
  }

  const isTableTypeSubm = type === TABLE_TYPE.SUBM

  return (
    <>
      <Toolbar className={classes.top}>

        <Tooltip title={'Filtr'}>
          <IconButton className={classes.filter} aria-label="filter list" onClick={() => setOpenFilter(!openFilter)}>
            <FilterListIcon/>
          </IconButton>
        </Tooltip>
      </Toolbar>

      {openFilter &&
        <Toolbar className={classes.filterWrap}>

          <MuiPickersUtilsProvider
            locale={'cs'}
            utils={MomentUtils}
          >
            <Grid container justifyContent="space-around">

              {isTableTypeSubm &&
                <>
                  <TextField
                    className={classes.formControl}
                    style={{ minWidth: 230 }}
                    select
                    label={'Typ podání'}
                    value={msgType}
                    onChange={e => setMsgType(e.target.value)}
                  >
                    <MenuItem value="">- Všechny -</MenuItem>
                    {Object.entries(EKOM_TYPES_LABEL).map(([key, val]) =>
                      <MenuItem key={key} value={key}>{val}</MenuItem>
                    )}
                  </TextField>
                  <TextField
                    className={classes.formControl}
                    style={{ minWidth: 230 }}
                    select
                    label={'Stav podání'}
                    value={msgState}
                    onChange={e => setMsgState(e.target.value)}
                  >
                    <MenuItem value="">- Všechny -</MenuItem>
                    {Object.entries(EKOM_STATES_LABEL).map(([key, val]) =>
                      <MenuItem key={key} value={key}>{val}</MenuItem>
                    )}
                  </TextField>

                  <div className={classes.break}/>
                </>
              }

              {!isTableTypeSubm &&
                <TextField
                  className={classes.formControl}
                  variant="outlined"
                  id="input-with-icon-textfield-subject"
                  size="small"
                  label={'Hledat předmět'}
                  color="primary"
                  onChange={e => setSearchSubject(e.target.value)}
                  value={searchSubject}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        {searchSubject ?
                          <CloseIcon color="primary" onClick={() => setSearchSubject('')}
                                     style={{ cursor: 'pointer' }}/>
                          :
                          <SearchIcon color="primary"/>
                        }
                      </InputAdornment>
                    ),
                  }}
                />
              }

              <TextField
                className={classes.formControl}
                variant="outlined"
                id="input-with-icon-textfield-contract"
                size="small"
                label={'Hledat zakázku'}
                color="primary"
                onChange={e => setSearchObject(e.target.value)}
                value={searchObject}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      {searchObject ?
                        <CloseIcon color="primary" onClick={() => setSearchObject('')} style={{ cursor: 'pointer' }}/>
                        :
                        <SearchIcon color="primary"/>
                      }
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                className={classes.formControl}
                variant="outlined"
                id="input-with-icon-textfield-org"
                size="small"
                label={'Hledat organizaci'}
                color="primary"
                onChange={e => setSearchOrg(e.target.value)}
                value={searchOrg}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      {searchOrg ?
                        <CloseIcon color="primary" onClick={() => setSearchOrg('')} style={{ cursor: 'pointer' }}/>
                        :
                        <SearchIcon color="primary"/>
                      }
                    </InputAdornment>
                  ),
                }}
              />

              <div className={classes.break}/>

              <KeyboardDatePicker
                keyboardIcon={<EventIcon color="primary"/>}
                disableFuture
                maxDateMessage={MAX_DATE}
                minDateMessage={MIN_DATE}
                invalidDateMessage={INVALID_DATE}
                autoOk={true}
                clearable
                variant="inline"
                format="DD.MM.YYYY"
                mask="__.__.____"
                label={'Od'}
                value={dateFrom}
                onChange={setDateFrom}
                InputProps={{
                  startAdornment: dateFrom ? (
                    <IconButton size="small" onClick={() => setDateFrom(null)}>
                      <ClearIcon color="primary"/>
                    </IconButton>
                  ) : null
                }}
              />

              <KeyboardDatePicker
                keyboardIcon={<EventIcon color="primary"/>}
                disableFuture
                maxDateMessage={MAX_DATE}
                minDateMessage={MIN_DATE}
                invalidDateMessage={INVALID_DATE}
                autoOk={true}
                clearable
                variant="inline"
                format="DD.MM.YYYY"
                mask="__.__.____"
                label={'Do'}
                value={dateTo}
                onChange={setDateTo}
                InputProps={{
                  startAdornment: dateTo ? (
                    <IconButton size="small" onClick={() => setDateTo(null)}>
                      <ClearIcon color="primary"/>
                    </IconButton>
                  ) : null
                }}
              />

              {!isTableTypeSubm &&
                <FormControl component="fieldset">
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={isRead}
                          onChange={e => {
                            setIsRead(e.target.checked)
                            setIsUnRead(false)
                          }}
                          name="isRead"
                        />
                      }
                      label="Pouze přečtené"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={isUnRead}
                          onChange={e => {
                            setIsUnRead(e.target.checked)
                            setIsRead(false)
                          }}
                          name="isUnRead"
                        />
                      }
                      label="Pouze nepřečtené"
                    />
                  </FormGroup>
                </FormControl>
              }

            </Grid>
            <Grid container justifyContent="space-evenly" style={{ width: 600 }}>
              <Button color="primary" variant="contained" className="mr-3"
                      disabled={!isFilterFill}
                      onClick={() => doFilter()}>Filtrovat</Button>

              <Button color="secondary" variant="contained" className="mr-3"
                      disabled={!isFilterActive}
                      onClick={() => resetFilter()}>Zrušit filtr</Button>

            </Grid>
          </MuiPickersUtilsProvider>

        </Toolbar>
      }
    </>
  )
}
